import { APP_ROUTES } from "@/constants/app-routes";
import { privateRoute } from "@/router/routes";
import { onboardingRoutes } from "@/router/step-routes";

/**
 * Route-class predicates shared by the auth redirectors. Centralized here so the
 * guards agree on what counts as a private / onboarding / main-app route instead
 * of each recomputing it from `privateRoute` / `onboardingRoutes`.
 *
 * Note: `privateRoute` already includes the onboarding step routes (spread in
 * `routes.tsx`), so `isMainAppRoute` subtracts them back out.
 */
export const isPrivateRoute = (path: string): boolean =>
  privateRoute.some((route) => route.path === path);

export const isOnboardingRoute = (path: string): boolean =>
  onboardingRoutes.some((route) => route.path === path) || path === APP_ROUTES.ONBOARDING_START;

export const isMainAppRoute = (path: string): boolean =>
  isPrivateRoute(path) && !isOnboardingRoute(path);

/** The bare app entry (`/`) — the route the native container loads on launch. */
export const isEntryRoot = (path: string): boolean => path === "/";
